import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { FeatureFlagKey } from "@repo/app-types/featureFlags/keys";

type FeatureFlagsState = readonly FeatureFlagKey[];

const initialState: FeatureFlagsState = [];

const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    setFeatureFlagKeys: (
      _state,
      action: PayloadAction<readonly FeatureFlagKey[]>,
    ) => action.payload,
  },
});

export const { setFeatureFlagKeys } = featureFlagsSlice.actions;

export default featureFlagsSlice.reducer;
